import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AboutFounderSection } from "../components/AboutFounderSection";
import { ContactSection } from "../components/ContactSection";
import { FeatureGrid } from "../components/FeatureGrid";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { SecuritySection } from "../components/SecuritySection";
import { TrustStrip } from "../components/TrustStrip";
import { WhoWeServe } from "../components/WhoWeServe";

export default function HomePage() {
  const signedOut = useSignedOutNotice();
  return (
    <>
      {signedOut && (
        <p className="signed-out-banner" role="status">
          You&rsquo;ve been signed out. Your return is saved &mdash; sign in any time to pick up where
          you left off.
        </p>
      )}
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <FeatureGrid />
        <WhoWeServe />
        <AboutFounderSection />
        <SecuritySection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}

/**
 * Signing out routes here with a one-shot flag so the exit is explicitly confirmed rather than
 * silently dropping the user on the marketing page. The flag is consumed on mount, so a reload or
 * a later visit shows nothing.
 */
function useSignedOutNotice(): boolean {
  const location = useLocation();
  const flagged = Boolean((location.state as { signedOut?: boolean } | null)?.signedOut);
  const [visible, setVisible] = useState(flagged);
  useEffect(() => {
    if (!flagged) return;
    window.history.replaceState({}, "", location.pathname);
    const timer = window.setTimeout(() => setVisible(false), 8000);
    return () => window.clearTimeout(timer);
  }, [flagged, location.pathname]);
  return visible;
}
